import { ElectricGridCountry } from "libraries/emission";
import { getBrowserTimezone } from "libraries/mapDefaultCenter";

/** Exact IANA timezone → grid country. */
const TIMEZONE_TO_GRID: Record<string, ElectricGridCountry> = {
  "Europe/Oslo": "norway",
  "Europe/Paris": "france",
  "Europe/London": "uk",
  "Europe/Dublin": "uk",
  "Europe/Berlin": "germany",
  "Europe/Stockholm": "sweden",
  "Europe/Madrid": "spain",
  "Europe/Rome": "italy",
  "Europe/Amsterdam": "netherlands",
  "Europe/Brussels": "netherlands",
  "Europe/Zurich": "germany",
  "Europe/Vienna": "germany",
  "Europe/Warsaw": "germany",
  "Europe/Prague": "germany",
  "Europe/Copenhagen": "sweden",
  "Europe/Helsinki": "sweden",
  "Europe/Lisbon": "spain",
  "Europe/Athens": "italy",
  "Europe/Bucharest": "germany",
  "America/New_York": "us",
  "America/Chicago": "us",
  "America/Denver": "us",
  "America/Los_Angeles": "us",
  "America/Toronto": "canada",
  "America/Vancouver": "canada",
  "America/Montreal": "canada",
  "America/Sao_Paulo": "brazil",
  "America/Buenos_Aires": "brazil",
  "America/Mexico_City": "us",
  "Asia/Tokyo": "japan",
  "Asia/Shanghai": "china",
  "Asia/Hong_Kong": "china",
  "Asia/Singapore": "world",
  "Asia/Kolkata": "india",
  "Asia/Dubai": "world",
  "Asia/Seoul": "japan",
  "Australia/Sydney": "australia",
  "Australia/Melbourne": "australia",
  "Pacific/Auckland": "australia",
  "Africa/Johannesburg": "world",
  "Africa/Cairo": "world",
  "Africa/Lagos": "world",
  "Africa/Casablanca": "world",
  "Atlantic/Azores": "world",
};

const PREFIX_TO_GRID: Array<{ prefix: string; country: ElectricGridCountry }> =
  [
    { prefix: "Europe/", country: "germany" },
    { prefix: "America/", country: "us" },
    { prefix: "Asia/", country: "world" },
    { prefix: "Australia/", country: "australia" },
    { prefix: "Pacific/", country: "world" },
    { prefix: "Africa/", country: "world" },
    { prefix: "Atlantic/", country: "world" },
    { prefix: "Indian/", country: "world" },
  ];

/** Map browser (or given) IANA timezone to an electricity grid country key. */
export const getElectricGridCountryFromTimezone = (
  timeZone: string = getBrowserTimezone()
): ElectricGridCountry => {
  if (timeZone && TIMEZONE_TO_GRID[timeZone]) {
    return TIMEZONE_TO_GRID[timeZone];
  }

  const region = PREFIX_TO_GRID.find(({ prefix }) =>
    timeZone.startsWith(prefix)
  );
  return region?.country ?? "world";
};
